import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const AgencyRoutes = defineRoute({
    home: {
        route: {
            path: "/agency",
            component: () => loadView(import("./AgencyHome.vue")),
        },
    },
    detail: {
        route: {
            path: "/agency/:id",
            component: () => loadView(import("./AgencyDetail.vue")),
        },
        build(id: string) {
            return `/agency/${id}`;
        },
    },
});
